/**
 * @desc 查询受益部门明细
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.RevenueDepartmentResponseDto>;
export function request(id: number, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/revenueDepartment/getDetail/${id}`, {
      method: "GET",

      ...options,
    }),
  );
}
